import React from 'react';
import { getSelectedOption } from './commonRingUtils';
import { IPageData } from './Pages';
import { ITab, ITabs } from '../types/customizer';
import SwatchFilter from '../components/SwatchFilter';
import SizeFilter from '../components/SizeFilter';
import Summary from '../components/Summary';
import BoxFilter from '../components/BoxFilter';
import { getCategorizedOptions } from './basic';
import { getArrangementItems } from './arrangementItems';

export const getV2PageData = (props: IPageData) => {
  const { product: productData, subpath, storeData, isBuildFromScratch } = props;
  const product = { ...productData };
  product.categories = getCategorizedOptions('womens', storeData);
  const items: ITabs = [
    {
      title: 'Category',
      helzberg_key: 'category',
      eventKey: 'category',
      component: BoxFilter,
      isEnabled: true,
      isSelected: isBuildFromScratch,
      content: {
        hasSwatch: true,
        fieldType: 'category',
        options: product.categories,
        selectedOption: getSelectedOption(product.categories)
      }
    },
    {
      title: 'Style',
      helzberg_key: 'anniversary_style',
      label: 'Style',
      eventKey: 'anniversary_style',
      component: SwatchFilter,
      isEnabled: product.style?.length > 0,
      isSelected: !isBuildFromScratch,
      content: {
        // showDefaultTitle: false,
        // displayShowMoreOption: false,
        // meta: getFilterMetaData(product, 'style'),
        // warning: getWarning(product, 'style'),
        hasSwatch: true,
        fieldType: 'styles',
        options: product.style,
        selectedOption: getSelectedOption(product.style)
      }
    },
    {
      title: 'Material',
      helzberg_key: 'material',
      label: 'Material',
      eventKey: 'material',
      component: SwatchFilter,
      isEnabled: product.ring_material?.length > 0,
      content: {
        // showDefaultTitle: false,
        // displayShowMoreOption: false,
        // meta: getFilterMetaData(product, 'ring_material'),
        // warning: getWarning(product, 'ring_material'),
        hasSwatch: true,
        fieldType: 'ring_materials',
        options: product.ring_material,
        selectedOption: getSelectedOption(product.ring_material)
      }
    },
    {
      title: 'Arrangement',
      helzberg_key: 'arrangement',
      eventKey: 'arrangement',
      items: getArrangementItems(product),
      tabStyle: 'box'
    },
    {
      title: 'Size',
      helzberg_key: 'size',
      label: 'Ring Size',
      eventKey: 'ringSize',
      component: SizeFilter,
      isEnabled: product.size?.length > 0,
      content: {
        // showDefaultTitle: true,
        // displayShowMoreOption: false,
        // meta: getFilterMetaData(product, 'size'),
        // warning: getWarning(product, 'size'),
        hasSwatch: false,
        fieldType: 'size',
        options: product.size || [],
        selectedOption: getSelectedOption(product.size)
      }
    },
    {
      title: 'Summary',
      helzberg_key: 'summary',
      eventKey: 'summary',
      component: Summary,
      isEnabled: subpath !== 'customize'
    }
  ];

  const filtered = items.filter((tab: ITab) => tab.isEnabled || tab.items?.length);
  return filtered;
};
